// Data Images

export default (data, value) => {
  Object.keys(data).forEach(key => {
    if (key === value.key) {
      if (value.type === 'add') {
        if (typeof data[value.key].value === 'undefined') {
          data[value.key].value = []
        }
        data[value.key].value.unshift({
          id: null,
          name: value.value.name,
          data: value.value.value
        })
        if (data.cover.value === null) {
          data.cover.value = 1
        }
      } else if (value.type === 'cover') {
        data.cover.value = value.value + 1
      } else {
        let coverRemove = false
        data[value.key].value = data[value.key].value.filter((item, i) => {
          if (i !== value.value) {
            return item
          } else {
            if ((data.cover.value - 1) === i) {
              coverRemove = !coverRemove
            }
          }
        })
        if (coverRemove && data[value.key].value.length > 0) {
          data.cover.value = 1
        } else {
          data.cover.value = null
        }
      }
    }
  })
  return data
}
